import { render, staticRenderFns } from "./Specs.vue?vue&type=template&id=61bfe59e"
import script from "./Specs.vue?vue&type=script&lang=js"
export * from "./Specs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports